import { useRef, useEffect } from 'react';

import Title from '@zenbusiness/common-components/Title';
import lottieWeb from 'lottie-web';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';

import { generateUrl } from '../SharedAsset/index';

const useStyles = makeStyles(() => ({
  title: {
    marginTop: '20px'
  }
}));

const AnimatedLoading = ({ width, msg }) => {
  const lottieContainerRef = useRef(null);
  const classes = useStyles();
  useEffect(() => {
    lottieWeb.loadAnimation({
      container: lottieContainerRef.current,
      path: generateUrl('/lottie/animated-floating-rovie.json'),
      loop: true,
      autoPlay: true,
      name: 'lottie'
    });
  }, []);

  return (
    <Grid container direction="column" alignItems="center" sx={{ marginTop: '100px' }}>
      <div style={{ width: `${width}px`, height: `${width}px` }} ref={lottieContainerRef} />
      <Title
        level={1}
        variant="hg"
        className={classes.title}
      >
        Hang tight...
      </Title>
      <Title
        level={2}
        variant="sm"
        align="center"
        color="focus70"
      >
        { msg }
      </Title>
    </Grid>
  );
};

AnimatedLoading.defaultProps = {
  msg: ''
};

AnimatedLoading.propTypes = {
  width: PropTypes.number.isRequired,
  msg: PropTypes.string
};

export default AnimatedLoading;
